import { render, staticRenderFns } from "./PdpTilesForCustomizations.vue?vue&type=template&id=0dc8ce2b&scoped=true&"
import script from "./PdpTilesForCustomizations.vue?vue&type=script&lang=js&"
export * from "./PdpTilesForCustomizations.vue?vue&type=script&lang=js&"
import style0 from "./PdpTilesForCustomizations.vue?vue&type=style&index=0&id=0dc8ce2b&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8ce2b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppInfoModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppInfoModal.vue').default})
